import { createSVGWrapper } from "./SVGWrapper";

/**
 * @deprecated This icon is deprecated. Please use Lucide React icons instead.
 * @see https://lucide.dev/ for available icons
 * @example
 * import { Table } from "lucide-react";
 * // Use <Table /> instead
 */
export const ViewTableIcon = createSVGWrapper(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M4 5C3.44772 5 3 5.44772 3 6V18C3 18.5523 3.44772 19 4 19H20C20.5523 19 21 18.5523 21 18V6C21 5.44772 20.5523 5 20 5H4ZM5 7V17H8.33337V7H5ZM13.6666 17H10.3334V7H13.6666V17ZM15.6666 17H19V7H15.6666V17Z"
    clipRule="evenodd"
  />
);
